import { useCallback } from 'react';

import { useQueryCriteriasState } from '../query/useQueryCriteriasState';
import { useCurrentCriteriaIndex } from './useCurrentCriteriaIndex';
import { useQueryStateContext } from '../../contexts';

export const useRemoveCriteria = () => {
  const { setCriterias } = useQueryCriteriasState();
  const { resetQueryId } = useQueryStateContext();
  const index = useCurrentCriteriaIndex();
  return useCallback(() => {
    setCriterias((criterias) => criterias.filter((_, i) => i !== index));
    resetQueryId();
  }, [setCriterias, index]);
};
